import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";
import PropTypes from "prop-types";

import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftButton from "components/SoftButton";

function ComingSoon({ title, description, productUrl }) {
  return (
    <Card>
      <SoftBox p={3} textAlign="center">
        <SoftBox
          display="grid"
          justifyContent="center"
          alignItems="center"
          bgColor="info"
          color="white"
          width="4rem"
          height="4rem"
          shadow="md"
          borderRadius="lg"
          mb={2}
          mx="auto"
        >
          <Icon fontSize="default">upcoming</Icon>
        </SoftBox>
        <SoftTypography variant="h3" fontWeight="medium" textTransform="capitalize" mb={1}>
          {title}
        </SoftTypography>
        <SoftTypography variant="body2" fontWeight="regular" color="text" mb={3}>
          {description}
        </SoftTypography>
        {productUrl && (
          <SoftButton 
            component="a"
            href={productUrl}
            target="_blank"
            rel="noopener noreferrer"
            variant="gradient" 
            color="info" 
            size="small"
          >
            Mehr erfahren
          </SoftButton>
        )}
      </SoftBox>
    </Card>
  );
}

ComingSoon.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  productUrl: PropTypes.string
};

export default ComingSoon;